import { WidgetChartOptions } from 'app/modules/widget/components/widget-chart/widget-chart.component';
import { Dashboard, Widget } from 'app/providers/bridge-api/dashboard.service';
import { AbstractChartReport } from '../chart-report-abstract/chart-report-abstract';

export interface BigNumberMetadataResult {
  docs: number;
  result: number;
}

export function getBigNumberMetadataResultFromReport(
  options: WidgetChartOptions,
  report
): BigNumberMetadataResult {
  let resultScore = report.items.data.metadata[0].score;

  if (options.boxDirection) {
    switch (options.boxDirection) {
      default:
      case 'TOP':
        resultScore = report.items.data.metadata[0].topScore;
        break;
      case 'BOTTOM':
        resultScore = report.items.data.metadata[0].bottomScore;
        break;
    }
  }

  return {
    docs: report.items.data.metadata[0].docs,
    result: resultScore,
  };
}

export class BigNumberMetadataReport extends AbstractChartReport {
  public reportName = 'documentNumericMetadata';
  public reportHandler = (
    _dashboard: Dashboard,
    _widget: Widget<WidgetChartOptions>,
    _response: any,
    _options: any
  ) => ({});

  public getFields(): string[] {
    return [];
  }

  isAnalyticItemSupported(analyticItem) {
    return ['documents', 'metadata'].indexOf(analyticItem) > -1;
  }

  public getParams() {
    const params = super.getParams();

    params.boxSize = this.options.boxSize;
    params.scoringStrategy = this.options.scoringStrategy;
    params.boxDirection = this.options.boxDirection;
    params.scoreRange = this.options.scoreRange;

    return params;
  }

  public async processResponse(
    report: any,
    _filterQuery?: string
  ): Promise<BigNumberMetadataResult> {
    return getBigNumberMetadataResultFromReport(this.options, report);
  }
}
